<div *ngIf="auths">
  <micro-picklist title="Roles" idField="auth" displayField="auth" [all]="auths" [(selectedIds)]="selectedAuths" (selectedIdsChange)="onNgModelChange($event)"  [helpCallback]="helpCallback" [component]="this"></micro-picklist>
</div>
